export default __webpack_public_path__ + "static/media/adebayo.3db120c2.png";